var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("data-table", {
    ref: "table",
    staticClass: "table table table-striped",
    attrs: {
      "filter-position": _vm.tableFilterPosition,
      columns: _vm.columns,
      data: _vm.notifications,
      loading: _vm.isLoading,
      "datatable-options": _vm.dataTablesOptions,
      "datatable-classes": ["table-bordered"]
    },
    on: { cancel: _vm.cancel }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }